
<div class="container-fluid">
    <div class="row testimonial_row_wrapper">
        <div class="col-md-2 testimon">
            <div class="logo_wrapper">
                <h3 class="type_title">Testimonies </h3>
            </div>
            <ul class="list-unstyled">
                <div class="type_list" (click)="testOf(2);">
                    <a class="owner">Home Owners </a>
                    <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                </div>
                <div class="type_list" (click)="testOf(1)">
                    <a class="owner">Tenants </a>
                    <fa-icon [icon]="faAngleRight" class="fa-lg" style="font-size: 16px" ></fa-icon>
                </div>
            </ul>
        </div>
        <div class="col-md-9 wrapper_test">
            <div>
                <h1 class="own_test"> {{ userType }} Testimonies </h1>
            </div>
            <div class="container testimony_container">
                <div class="row testimonial_wrapper" id="testimony_carousal">
                    <div class="col-lg-3 testimonial_card" *ngFor="let testm of testimonial ;let i = index">
                        <div class="author-image"  >                
                            <div *ngIf="testm.user_img != null">
                                <img src="{{testm.user_img}}" class="test_user" alt="YourOwnROOM Testimonial">
                            </div>
                            <div *ngIf="testm.user_img == null ">
                                <img src="assets/images/testimonial_img.png" class="test_user">
                            </div>
                        </div>
                        <p class="author-name">{{testm.author}}<span style="color: black; font-size: 14px;">, {{testm.authormeta}}</span></p>
                        <p style="margin: 0;" id="{{'testimonial_' + i }}"  class="limitTextHeight">{{testm.testimonial }}</p>
                        <p>  </p>
                        <p *ngIf=" testm.testimonial.length > 170 " class="read-more" id="{{'readMore_' + i}}"(click)="showText(i)" >Read More</p>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div> 